export default __webpack_public_path__ + "static/media/886.5e42a52e.png";